module.exports = __webpack_public_path__ + "static/media/header_bg.9e6d8119.png";